import type { Tool } from './Tool';
import { Grid } from '../Grid';
import { Particle } from '../Particle';
import { Empty } from '../particles/Empty';

export interface StoredParticle {
    dx: number;
    dy: number;
    particle: Particle;
    originalX: number;
    originalY: number;
}

export class DragTool implements Tool {
    name = 'drag';
    private storedParticles: StoredParticle[] | null = null;

    get draggingParticles(): StoredParticle[] | null {
        return this.storedParticles;
    }

    /**
     * 对于 DragTool，apply 方法不执行任何操作，
     * 因为所有的逻辑都在 handleDown 和 handleUp 中。
     */
    apply(x: number, y: number, grid: Grid, size: number): void {
        // 可以在这里添加拖拽过程中的预览逻辑
    }

    /**
     * 鼠标按下时：抓取范围内的所有非空粒子
     */
    handleDown(x: number, y: number, grid: Grid, size: number): void {
        this.storedParticles = [];
        const r = size;

        for (let dy = -r; dy <= r; dy++) {
            for (let dx = -r; dx <= r; dx++) {
                const px = x + dx;
                const py = y + dy;

                // 检查边界
                if (px >= 0 && px < grid.width && py >= 0 && py < grid.height) {
                    const p = grid.get(px, py);
                    // 只抓取非空且可混合（移动）的粒子
                    // 并且必须是液体 (isLiquid) 或粉状固体 (isPowder)
                    // 且没有被胶水固定 (isGlued)
                    if (p && !p.empty && p.props.isMixable && (p.props.isLiquid || p.props.isPowder) && !p.props.isGlued) {
                        this.storedParticles.push({
                            dx,
                            dy,
                            particle: p,
                            originalX: px,
                            originalY: py
                        });
                        // 将原位置设为空
                        grid.set(px, py, new Empty());
                    }
                }
            }
        }
    }

    /**
     * 鼠标松开时：将抓取的粒子放置到新位置
     */
    handleUp(x: number, y: number, grid: Grid, size: number): void {
        if (!this.storedParticles) return;

        for (const { dx, dy, particle, originalX, originalY } of this.storedParticles) {
            const px = x + dx;
            const py = y + dy;

            // 检查边界
            if (px >= 0 && px < grid.width && py >= 0 && py < grid.height) {
                const target = grid.get(px, py);
                
                if (target && !target.empty) {
                    // 目标位置非空，不进行放置，粒子回到原位
                    grid.set(originalX, originalY, particle);
                } else {
                    // 目标位置为空，直接放置
                    grid.set(px, py, particle);
                }
            } else {
                // 越界了，不做任何操作（粒子销毁）
                // 因为 handleDown 时已经把原位置设为空了
            }
        }
        
        // 清空暂存区
        this.storedParticles = null;
    }
}
